var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"goTop"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.goTopShow),expression:"goTopShow"}],staticClass:"goTop",class:_vm.ismobile ? 'gom' : 'gopc',on:{"click":_vm.goTop}},[_c('i',{staticClass:"iconfont goTopIcon",class:_vm.ismobile ? 'icon-zhiding ' : 'icon-zhiding'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }